import { render } from "./contentPage.vue?vue&type=template&id=a3871ae2"
import script from "./contentPage.vue?vue&type=script&lang=js"
export * from "./contentPage.vue?vue&type=script&lang=js"

import "./contentPage.vue?vue&type=style&index=0&id=a3871ae2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__